import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const HanaPaymentMob = () => {
  return <CommonProcess />;
};

export default HanaPaymentMob;
